/* ===============================
   GLOBAL CART STATE
   =============================== */
window.__gaCartState = {
  prevItems: {}
};

/* ===============================
   ADD TO CART
   =============================== */
  (function () {
    if (!window.fetch) return;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var resource = args[0];
      var config = args[1] || {};
      var url = typeof resource === 'string' ? resource : resource.url;
      var method = (config.method || 'GET').toUpperCase();
      var isCartAdd = url.indexOf('/cart/add') !== -1 && method === 'POST';

      return originalFetch.apply(this, args).then(function (response) {
        if (!isCartAdd || !response.ok) return response;

        fetch('/cart.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            if (!cart || !cart.items || !cart.items.length) return;

            var item = cart.items[cart.items.length - 1];

            var currency =
              (window.Shopify && Shopify.currency && Shopify.currency.active) ||
              cart.currency ||
              document.documentElement.getAttribute('data-currency') ||
              '{{ shop.currency }}';

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: currency,
                value: item.final_line_price / 100,
                items: [
                  {
                    item_id: item.sku || item.variant_id,
                    item_name: item.product_title,
                    item_brand: item.vendor,
                    item_variant: item.variant_title,
                    price: item.final_price / 100,
                    quantity: item.quantity
                  }
                ]
              }
            });
          })
          .catch(function () {});

        return response;
      });
    };
  })();

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart_attempt'
      });
    },
    true
  );


/* ===============================
   REMOVE FROM CART
   =============================== */
function removeItemEvent(cartData) {
  if (!cartData?.items_removed?.length) return;

  const items = cartData.items_removed.map((item, index) => ({
    item_id: item.sku || item.product_id,
    item_name: item.product_title,
    item_variant: item.variant_title,
    price: item.price / 100,
    quantity: item.quantity,
    index: index + 1
  }));

  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      currency: Shopify.currency.active,
      value: items[0].price * items[0].quantity,
      items
    }
  });
}

/* ===============================
   BEGIN CHECKOUT
   =============================== */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
  if (!btn) return;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: Shopify.currency.active,
          value: cart.total_price / 100,
          items: cart.items.map((item, index) => ({
            item_id: item.sku || item.product_id,
            item_name: item.product_title,
            item_brand: item.vendor,
            item_variant: item.variant_title,
            price: item.price / 100,
            quantity: item.quantity,
            index: index + 1
          }))
        }
      });
    });
}, true);

/* ===============================
   SELECT ITEM (PLP + SEARCH)
   =============================== */
document.addEventListener('click', function (e) {
  const link = e.target.closest('.card-wrapper a');
  if (!link) return;

  e.preventDefault();

  const card = link.closest('.card-wrapper');

  const itemName =
    card.querySelector('.card__heading a')?.textContent.trim();

  const priceText =
    card.querySelector('.price-item--regular')?.textContent || '';

  const price = Number(priceText.replace(/[^0-9.]/g, ''));

  const itemId =
    card.querySelector('.product-sku')?.textContent.trim();

  const isSearchPage = document
    .getElementById('MainContent')
    ?.classList.contains('template---search');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      item_list_name: isSearchPage ? 'Search Results' : 'Collection',
      items: [{
        item_id: itemId,
        item_name: itemName,
        price: price,
        quantity: 1
      }]
    }
  });

  setTimeout(() => {
    window.location.href = link.href;
  }, 150);
});


/* ===============================
   QUANTITY CHANGE
   =============================== */
function trackQuantityChange(cart) {
  if (!cart?.items) return;

  const prev = window.__gaCartState.prevItems;
  const current = {};

  cart.items.forEach(item => {
    current[item.key] = item.quantity;

    if (prev[item.key] !== undefined && prev[item.key] !== item.quantity) {
      window.dataLayer.push({
        event: "quantity_change",
        ecommerce: {
          currency: Shopify.currency.active,
          items: [{
            item_id: item.sku || item.product_id,
            item_name: item.product_title,
            item_variant: item.variant_title,
            price: item.price / 100,
            quantity: item.quantity,
            quantity_delta: item.quantity - prev[item.key]
          }]
        }
      });
    }
  });

  window.__gaCartState.prevItems = current;
}

/* ===============================
   DAWN CART UPDATE HOOK (PAGE + DRAWER)
   =============================== */
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (!event?.cartData) return;

  const cart = event.cartData;

  if (cart.items_removed?.length) {
    removeItemEvent(cart);
  }

  trackQuantityChange(cart);
});

function trackAddToWishlist(product) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "add_to_wishlist",
    ecommerce: {
      currency: Shopify.currency.active,
      value: product.price,
      items: [{
        item_id: product.sku || product.id,
        item_name: product.name,
        item_brand: product.brand,
        item_variant: product.variant,
        price: product.price,
        quantity: 1
      }]
    }
  });
}

/* ===============================
   SCROLL DEPTH (GLOBAL)
   =============================== */
(function () {
  const thresholds = [25, 50, 75, 90];
  const fired = new Set();

  function getScrollPercent() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return 0;
    return Math.round((scrollTop / docHeight) * 100);
  }

  window.addEventListener('scroll', () => {
    const percent = getScrollPercent();

    thresholds.forEach(t => {
      if (percent >= t && !fired.has(t)) {
        fired.add(t);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'scroll_depth',
          percent_scrolled: t,
          page_type: document.body.dataset.template || document.body.className
        });
      }
    });
  });
})();

/* ===============================
   PDP TAB / ACCORDION CLICKS
   =============================== */
document.addEventListener('click', function (e) {
  if (!document.body.classList.contains('template-product')) return;

  const tab = e.target.closest(
    '.pdp__subheader-item, details > summary, .accordion__title'
  );
  if (!tab) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pdp_tab_click',
    tab_name: tab.textContent.trim(),
    page_type: 'PDP'
  });
});

/* ===============================
   PDP IMAGE GALLERY
   =============================== */
document.addEventListener('click', function (e) {
  if (!document.body.classList.contains('template-product')) return;

  const el = e.target.closest(
    '.product-media__image, .slider-button, .thumbnail'
  );
  if (!el) return;

  let interaction = 'unknown';
  if (el.classList.contains('slider-button--next')) interaction = 'next';
  if (el.classList.contains('slider-button--prev')) interaction = 'prev';
  if (el.classList.contains('thumbnail')) interaction = 'thumbnail';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pdp_image_interaction',
    interaction_type: interaction,
    page_type: 'PDP'
  });
});

/* ===============================
   PDP QUANTITY BUTTON CLICKS
   =============================== */
document.addEventListener('click', function (e) {
  if (!document.body.classList.contains('template-product')) return;

  const btn = e.target.closest('.quantity-selector__button');
  if (!btn) return;

  const action = btn.querySelector('.icon--plus') ? 'increase' : 'decrease';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pdp_quantity_click',
    action,
    page_type: 'PDP'
  });
});

